define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/BooleanController",
	"csi/locale",
	"csi/xml"
], function(declare, _, BooleanController, locale, xml) {

	return declare(BooleanController, {
		/**
		 * Return part material node
		 * @return {C8Node}
		 */
		getPartMaterial() {
			return this.m_cache.get(this.getNode().__Parent__);
		},

		/**
		 * @override
		 * Do not allow last color to be hidden
		 */
		process() {
			const {OnlyForColors, PartMaterialColors} = this.getPartMaterial();
			const newValue = this._getCheckboxValue();

			if (newValue && ((OnlyForColors.length === 1) || (!OnlyForColors.length && (PartMaterialColors.length === 1)))) {
				// if hiding the last/only color, then display error indicating PartMaterial must apply to at least one color
				this.displayErrorDialog({
					message: locale.resource("HideProductColor_ErrorLast"),
					onResponse: () => this.postProcess()
				});
			} else {
				this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Call PartMaterialAddToOnlyForColors or PartMaterialRemoveFromOnlyForColors
		 * depending on if boolean is selected or not
		 */
		toWriter: function() {
			const pm = this.getPartMaterial();
			const pmcBomColor = this.getNode().PMCBOMColor;

			if (this.newValue == true) {
				this.m_writer.callMethod("Specification", "PartMaterialRemoveFromOnlyForColors")
					.addParameter("ParentURL", xml.ATTR_REF, pm.$URL)
					.addParameter("RemoveURLs", xml.ATTR_REFLIST, [pmcBomColor]);
			} else {
				this.m_writer.callMethod("Specification", "PartMaterialAddToOnlyForColors")
					.addParameter("ParentURL", xml.ATTR_REF, pm.$URL)
					.addParameter("AddURLs", xml.ATTR_REFLIST, [pmcBomColor]);
			}

			this.bRefreshNode = true;
		}
	});
});